"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccommodationHotelBookingType;
(function (AccommodationHotelBookingType) {
    AccommodationHotelBookingType[AccommodationHotelBookingType["Own"] = 0] = "Own";
    AccommodationHotelBookingType[AccommodationHotelBookingType["CompanyProvided"] = 1] = "CompanyProvided";
})(AccommodationHotelBookingType || (AccommodationHotelBookingType = {}));
exports.default = AccommodationHotelBookingType;
